import React, { useMemo, useState } from "react";
import useAuth from "../../../../Hooks/useAuth";
import usePermission from "../../../../Hooks/usePermission";
import { useFirmUsersData } from "../../../../Hooks/dealerRoles/useFirmUsersData";
import { useGetDealerRolesRoleTemplatesQuery } from "../../../../store";
import { EmptyState } from "../../../shared";
import { firmTabPermission } from "../../../../utils/firmUtils";
import {
  ALL_TEMPLATES,
  countByTemplate,
  templateFilterFor,
  userTemplateId,
} from "../../../../utils/templateGrouping";
import UsersTab from "../storageRoles/UsersTab";
import RoleTemplatesTab from "./RoleTemplatesTab";

/**
 * KULLANICILAR + KULLANICI ŞABLONLARI tek sekmede (#298, bayi paneli).
 * Solda şablon sütunu, sağda kullanıcı listesi (salt okunur — kullanıcı
 * detayı route'u bayiye kapalı). Liste izni firma tipine göre
 * `dealers.users` / `customers.users`, sütun `firms.roleTemplatesRead`.
 */
export default function DealerRolesUsersTab({ firm }) {
  const { auth } = useAuth();
  const { hasPermission } = usePermission();
  const canUsers = hasPermission(firmTabPermission(firm, "firms.users", { role: "dealer" }));
  const canTemplates = hasPermission("firms.roleTemplatesRead");
  const [selectedId, setSelectedId] = useState(ALL_TEMPLATES);

  const data = useFirmUsersData(
    canUsers ? { id: firm?._id, token: auth.accessToken } : { id: null, token: null }
  );
  // RoleTemplatesTab ile aynı argüman — RTK Query tek istek atar.
  const { data: templatesRes } = useGetDealerRolesRoleTemplatesQuery(
    { token: auth.accessToken, id: firm?._id },
    { skip: !firm?._id || !canTemplates }
  );
  const templates = useMemo(() => templatesRes?.data?.templates || [], [templatesRes]);

  const stats = useMemo(
    () => countByTemplate(data.users, templates, userTemplateId),
    [data.users, templates]
  );
  const extraFilter = useMemo(
    () => (selectedId === ALL_TEMPLATES ? undefined : templateFilterFor(selectedId, templates, userTemplateId)),
    [selectedId, templates]
  );

  return (
    <div className="flex flex-col md:flex-row h-full min-h-0">
      {canTemplates && (
        <RoleTemplatesTab firm={firm} selectedId={selectedId} onSelect={setSelectedId} stats={stats} />
      )}
      <div className="flex-1 min-w-0 min-h-0 flex flex-col">
        {canUsers ? (
          <UsersTab
            firm={firm}
            readOnly={true}
            externalData={data}
            extraFilter={extraFilter}
            hideRoleFilter={canTemplates}
          />
        ) : (
          <EmptyState
            message="Kullanıcı listesini görme yetkiniz yok"
            suggestion="Şablonları soldan yönetebilirsiniz."
          />
        )}
      </div>
    </div>
  );
}
